import script from "./StudentNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentNotes.vue?vue&type=script&setup=true&lang=js"

import "./StudentNotes.vue?vue&type=style&index=0&id=264b1394&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264b1394"]])

export default __exports__